import  {FieldType}  from 'common/consts/fieldType';

export const AddressIsEditable=(contactDetailsConfigurationModel: any):
boolean=>{
     return(contactDetailsConfigurationModel != null &&
        contactDetailsConfigurationModel.addressFields != null &&
        (contactDetailsConfigurationModel.addressFields.addressLine1 == FieldType.Editable ||
        contactDetailsConfigurationModel.addressFields.addressLine2 == FieldType.Editable ||
        contactDetailsConfigurationModel.addressFields.addressLine3 == FieldType.Editable ||
        contactDetailsConfigurationModel.addressFields.addressLine4 == FieldType.Editable ||
        contactDetailsConfigurationModel.addressFields.addressLine5 == FieldType.Editable ||
        contactDetailsConfigurationModel.addressFields.houseNumber == FieldType.Editable ||
        contactDetailsConfigurationModel.addressFields.flatNumber == FieldType.Editable ||
        contactDetailsConfigurationModel.addressFields.streetName == FieldType.Editable ||
        contactDetailsConfigurationModel.addressFields.postalCode == FieldType.Editable ||
        contactDetailsConfigurationModel.addressFields.city == FieldType.Editable ||
        contactDetailsConfigurationModel.addressFields.country == FieldType.Editable ||
        contactDetailsConfigurationModel.addressFields.addressLine1 == FieldType.FixedValues ||
        contactDetailsConfigurationModel.addressFields.addressLine2 == FieldType.FixedValues ||
        contactDetailsConfigurationModel.addressFields.addressLine3 == FieldType.FixedValues ||
        contactDetailsConfigurationModel.addressFields.addressLine4 == FieldType.FixedValues ||
        contactDetailsConfigurationModel.addressFields.addressLine5 == FieldType.FixedValues ||
        contactDetailsConfigurationModel.addressFields.houseNumber == FieldType.FixedValues ||
        contactDetailsConfigurationModel.addressFields.flatNumber == FieldType.FixedValues ||
        contactDetailsConfigurationModel.addressFields.streetName == FieldType.FixedValues ||
        contactDetailsConfigurationModel.addressFields.postalCode == FieldType.FixedValues ||
        contactDetailsConfigurationModel.addressFields.city == FieldType.FixedValues ||
        contactDetailsConfigurationModel.addressFields.country == FieldType.FixedValues))
    
}